let focusedElement: Element | null = null;

document.addEventListener(
  "focus",
  (e) => {
    focusedElement = e.target as Element;
  },
  true
);

export default function useFocusedElement() {
  return function getFocusedElement() {
    return focusedElement;
  };
}
